<template>
  <div ref="categoriesEl" class="categories">
    <template v-for="category in module.config.general.categories">
      <a
        v-if="category.isEnabled"
        :key="category.id"
        class="category"
        :style="categoriesElStyles"
        :href="category.url"
        @click="$emit('emittedClick', category)"
      >
        <p class="title">{{ category.title }}</p>
        <div v-if="module.config.general.showJobCounter" class="job-count">
          {{ getJobCountForCategory(category.title) }}
        </div>
      </a>
    </template>
  </div>
</template>

<script>
import categoriesModule from "../categoriesDefaultModuleProp.js";
import { categoriesComputed } from "../mixins/categories.js";

export default {
  name: "CategoriesTower",
  mixins: [categoriesComputed],
  props: {
    module: {
      type: Object,
      default() {
        return categoriesModule;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/shared.scss";

.categories {
  flex-direction: column;
  justify-content: center;
}

.category {
  --cr-category-hover-transform-amount: 40px;

  justify-content: space-between;
  align-items: center;
  align-self: stretch;

  border-bottom: 2px solid var(--categories-border-color);

  .title {
    flex-grow: 1;
    max-width: calc(80% - var(--cr-category-hover-transform-amount));
  }

  .job-count {
    flex-shrink: 0;
  }

  &:hover {
    border-bottom: 2px dotted var(--categories-border-color);

    .title {
      transform: translateX(var(--cr-category-hover-transform-amount));
    }
  }
}
</style>
